import { initializeApp } from 'firebase/app';
import { getToken } from 'firebase/messaging';
import { getMessaging } from 'firebase/messaging/sw';
import IdentityService from '../services/IdentityService';

// fcm webプッシュ通知向けの設定
export const getFirebaseConfig = () => ({
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  // authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  // databaseURL: 'https://project-id.firebaseio.com',
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  // storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID
  //measurementId: 'G-measurement-id'
});

/**
 * FCMが使えるかのチェック
 * @returns
 */
export const isSupportedFcm = () =>
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window;

/**
 * fcm トークン取得と、DyanmoへのToken登録
 * @param isEnabled コネクト側での通知制御フラグ
 */
export const updatePushToken = async (
  isEnabled: boolean,
  identityClient: IdentityService
) => {
  const app = initializeApp(getFirebaseConfig());
  const messaging = getMessaging(app);
  // getToken実行後にServiceWorkerが起動する
  await getToken(messaging, {
    vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY
  })
    .then(async (currentToken) => {
      if (currentToken) {
        console.log({ currentToken });

        // push tokenの送信
        identityClient.updatePushToken({
          pushToken: currentToken,
          enabled: isEnabled,
          isWebPush: true
        });
      } else {
        // Show permission request UI
        console.log(
          'No registration token available. Request permission to generate one.'
        );
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
};

/**
 * キャッシュとSWの削除
 */
export const clearChash = () => {
  caches.keys().then((cacheNames) => {
    cacheNames.forEach((cacheName) => {
      if (cacheName.startsWith('workbox-precache-v2')) {
        caches.delete(cacheName);
        console.log('worker cache 削除完了');
        navigator.serviceWorker
          .getRegistrations()
          .then(function (registrations) {
            // 登録されているworkerを全て削除する
            for (let registration of registrations) {
              registration.unregister();
            }
            console.log('sw 削除完了');
          });
      }
    });
  });
};
